import _default from './Label';
export { _default as default };